import { SVGProps } from 'react';
const SvgSlider03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10 18h11M3 18h3M6 20v-4M20 12h1M3 12h13M16 14v-4M14 6h7M3 6h7M10 8V4"
    />
  </svg>
);
export default SvgSlider03;
